import { createContext, useContext, useEffect, useState } from "react";
import { publicApi } from "./api";

const Ctx = createContext({ brand_name: "Solar Partner Network", operator: null, seo_overrides: {}, redirects: [] });

export function SiteProvider({ children }) {
  const [cfg, setCfg] = useState({ brand_name: "Solar Partner Network", operator: null, seo_overrides: {}, redirects: [], exclusive_window_hours: 48, payout_days_after_month_end: 15, primary_brand: "neutral", show_toshniwal_profile: true, show_pm_solar: true, apn_logo_enabled: false });
  useEffect(() => {
    publicApi.get("/public/config").then((r) => setCfg(r.data)).catch(() => {});
  }, []);
  return <Ctx.Provider value={cfg}>{children}</Ctx.Provider>;
}

export const useSite = () => useContext(Ctx);

export const NO_GUARANTEE =
  "Income, sales, lead quantity, project approvals and subsidies are not guaranteed unless a specific lawful written commitment states otherwise.";
export const DRAFT_NOTE =
  "Draft programme terms. Package names, prices and commission rates are provisional and subject to legal review and final signed agreements. No fees are being collected.";
